import React from 'react';
import { Link } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import { ConfigProvider } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHouse } from '@fortawesome/free-solid-svg-icons';
import { useTheme } from '../../context/ThemeContext';
import { getAntdThemeConfig } from '../../utils/antdTheme';
import { Wrapper, Content, Title, Subtitle, StyledButton, IconWrap } from './styles';

const NotFoundPage: React.FC = () => {
  const { isDarkMode } = useTheme();
  const theme = { mode: (isDarkMode ? 'dark' : 'light') as 'light' | 'dark' };

  return (
    <ThemeProvider theme={theme}>
      <ConfigProvider theme={getAntdThemeConfig(isDarkMode)}>
        <Wrapper>
          <Content>
            <Title level={1}>404</Title>
            <Subtitle>Oops! The page you are looking for does not exist.</Subtitle>
            <Link to="/dashboard">
              <StyledButton type="primary" size="large" aria-label="Go Back Home">
                <IconWrap>
                  <FontAwesomeIcon icon={faHouse} />
                </IconWrap>
                Go Back Home
              </StyledButton>
            </Link>
          </Content>
        </Wrapper>
      </ConfigProvider>
    </ThemeProvider>
  );
};

export default NotFoundPage;
